import Pagination from 'react-bootstrap/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { setPage } from '../../redux/slices/PaginationSlice';

const TablePagination = ({ totalElements }) => {
    const dispatch = useDispatch();
    const pagination = useSelector((state) => state.pagination);
    const pagesReminder = totalElements % pagination.size;
    let totalPages = pagesReminder > 0
        ? ~~(totalElements / pagination.size) + 1
        : ~~(totalElements / pagination.size);

    const handleClick = (number) => {
        dispatch(setPage(number));
    };

    return (
        <Pagination className='d-flex justify-content-center'>
            {pagination.page === 0 ? (
                <Pagination.First disabled />
            ) : (
                <Pagination.First onClick={() => handleClick(0)} />
            )}
            {pagination.page > 1 ? (
                <>
                    <Pagination.Item
                        onClick={() => handleClick(pagination.page - 2)}
                    >
                        {pagination.page - 1}
                    </Pagination.Item>
                </>
            ) : (
                <></>
            )}
            {pagination.page > 0 ? (
                <>
                    <Pagination.Item
                        onClick={() => handleClick(pagination.page - 1)}
                    >
                        {pagination.page}
                    </Pagination.Item>
                </>
            ) : (
                <></>
            )}
            <Pagination.Item active>{pagination.page + 1}</Pagination.Item>
            {pagination.page + 1 < totalPages ? (
                <>
                    <Pagination.Item
                        onClick={() => handleClick(pagination.page + 1)}
                    >
                        {pagination.page + 2}
                    </Pagination.Item>
                </>
            ) : (
                <></>
            )}
            {pagination.page + 2 < totalPages ? (
                <>
                    <Pagination.Item
                        onClick={() => handleClick(pagination.page + 2)}
                    >
                        {pagination.page + 3}
                    </Pagination.Item>
                </>
            ) : (
                <></>
            )}
            {pagination.page + 1 === totalPages ? (
                <Pagination.Last disabled />
            ) : (
                <Pagination.Last
                    onClick={() => handleClick(totalPages - 1)}
                />
            )}
        </Pagination>
    );
};

export default TablePagination;
